import React from 'react';
import { slide as Menu } from 'react-burger-menu';
import './BurgerMenu.scss';
import LinkMenu from '../../components/LinkMenu';
import burgerIcon from '../../images/icn-menu.svg';

function BurgerMenu() {
  return (
    <div className="burger-menu">
      <Menu
        width={'200px'}
        customBurgerIcon={
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            fill="white"
            class="bi bi-list"
            viewBox="0 0 13 13"
          >
            <path
              fill-rule="evenodd"
              d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"
            />
          </svg>
        }
      >
        <LinkMenu />
      </Menu>
    </div>
  );
}

export default BurgerMenu;
